import React__default from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';

var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    return React__default.createElement(ThemeProvider$1, { theme: theme }, children);
};

export { ThemeProvider as default };
